<template>
    <rkm-area
        title="Unidade solicitante"
        type="fieldset"
        class="mt-3"
    >

        <rkm-button
            @click="open()"
            color="primary"
            slot="trailing"
            small
            title="Adicionar unidade"
        >
            <rkm-icon icon="plus" />
        </rkm-button>

        <Form :data="data" />

        <Modal
            :data="data"
            ref="Modal"
        />
    </rkm-area>
</template>

<script>
// Components.
import Form from './Form'
import Modal from './components/Modal'

export default {
    components: { Form, Modal },
    methods: {
        open() {

            if (this.data.model.unidadesSolicitantes.length === 0) {

                this.showConfirmation(
                    `Para iniciar a parametrização das unidades solicitantes, qualquer unidade solicitante já existente
                        para as unidades de coleta será automaticamente excluída e precisará ser reconfigurada. Deseja continuar.
                        Deseja continuar?.`,
                    async () => this.handleUnidadeColeta()
                )

                return false
            }

            this.$refs.Modal.open()
        },
        handleUnidadeColeta() {

            this.data.model.unidades.forEach(unidade => {

                unidade.unidadeColetaSolicitante = [];
            });

            this.$refs.Modal.open()
        }
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>